<div class="{{ contentClass }}">
	<h2 mat-dialog-title class="{{ style }}">{{ dialogData.title }}</h2>
	<div mat-dialog-content>
		<p>{{ message }}</p>
		<mat-form-field *ngIf="inputType !== eFeedbackInputType.confirm" appearance="standard" class="width-100">
			<input matInput [placeholder]="placeholder" [type]="inputType" [formControl]="confirmInput" />
		</mat-form-field>
	</div>
	<div mat-dialog-actions class="row text-center mb-0">
		<button
			mat-stroked-button
			ngbAutoFocus
			class="col-5 responsive-button confirm-cancel-button"
			(click)="closeDialog()"
			i18n="cancel button title"
		>Cancel</button>
		<button mat-flat-button color="primary" class="col-5 responsive-button confirm-submit-button" (click)="save()">
			<span [hidden]="dialogData.okButton" i18n="ok or confirm button title">Ok</span>
			<span [hidden]="!dialogData.okButton">{{ dialogData.okButton }}</span>
		</button>
	</div>
</div>
